/** Current-periode (tahun ajaran + semester) reader shared by mutations. */

import { getById } from '../service';
import { COL } from '../../collections';
import type { SettingsDoc } from '../domains';

/** Cache of the current periode — app-settings changes rarely (per semester),
 * so rapid stage changes re-use the last read instead of one REST call each. */
let periodeCache: { value: { tahunAjaran: string; semester: string }; at: number } | null = null;
const PERIODE_TTL_MS = 60_000;

/** Read the current tahun ajaran + semester from the app-settings doc. */
export async function currentPeriode(): Promise<{ tahunAjaran: string; semester: string }> {
  const now = Date.now();
  if (periodeCache && now - periodeCache.at < PERIODE_TTL_MS) return periodeCache.value;
  try {
    const app = await getById<SettingsDoc>(COL.settings, 'app-settings');
    const tahunAjaran = app?.tahunAkademik ?? app?.tahunAjaran ?? '';
    const semester = app?.semester ?? '';
    const value = { tahunAjaran, semester };
    periodeCache = { value, at: now };
    return value;
  } catch {
    return { tahunAjaran: '', semester: '' };
  }
}
